import styled from "styled-components";

import List from "../../../../components/List";
import CellBox from "../../../../components/CellBox";
import { Calendar } from "react-vant";
import { useEffect, useMemo } from "react";
import { useState, useImperativeHandle, forwardRef } from "react";
import {ethers}from 'ethers'
import {
  getDay,
  date2block,
  block2date,
  fmoney,
} from "../../../../utils/utils";
import Tip from "./ClaimTip";
import ClaimConfrim from "./ClaimConfrim";
import { Modal, Toast } from "antd-mobile";
import useAccount from "../../hook";
import { useIntl } from "react-intl";
export default function ProfitTab({ ...props }) {
  const {
    claimProfit,
    harvestProfitByDay,
    harvestProfitByDateRange,
    getUnclaimReward,
    getClaimedReward,
    getHavestRecord,
    myAccount,
  } = useAccount();
  const [profits, setProfits] = useState({
    unclaim: 0,
    claim: 0,
  });
  const intl = useIntl();
  const [rangeDate, setRangeDate] = useState(() => {
    const now = Date.now();
    const endDate = getDay(now, 0);
    const startDate = getDay(now, -60);
    return [new Date(startDate), new Date(endDate)];
  });

  const [harvests, setHarvests] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (myAccount && myAccount.account) {
      loadHarvest();
      getProfit()
    }
  }, []);
  
  const getProfit = async () =>{
    const unclaim = await getUnclaimReward();
    const claim = await getClaimedReward();

    setProfits({
      unclaim,
      claim,
    });
  }
  const cellData = useMemo(
    () => [
      {
        label: intl.formatMessage({
          id: "pages.account.profit_unclaim",
          defaultMessage: "未領取的收益",
        }),
        text: fmoney(ethers.utils.formatEther(profits.unclaim), 2) + " RT",
      },
      {
        label: intl.formatMessage({
          id: "pages.account.profit_claim",
          defaultMessage: "已領取收益",
        }),
        text: fmoney(profits.claim, 2) + " RT",
      },
    ],
    [profits]
  );
  const loadHarvest = async (startDate, endDate) => {
    setLoading(true);
    const start = date2block(startDate || rangeDate[0]);
    const end = date2block(endDate || rangeDate[1]);
    const harvests = await getHavestRecord(start, end);
    console.log("harvests", harvests);
    setHarvests(harvests);
    setLoading(false);
  };

  const headers = [
    {
      prop: "block",
      render: (val) => {
        return block2date(val);
      },
    },
    {
      prop: "amount",
      render: (val, row) => {
        return (
          <span style={{ color: !row.status ? "#FF5C00" : "#969696" }}>
            {"+" + fmoney(val, 2) + " RT"}
          </span>
        );
      },
    },
    {
      prop: "status",
      render: (val) => {
        return (
          <span style={{ color: !val ? "#FF5C00" : "#969696" }}>
            {!val
              ? intl.formatMessage({
                  id: "pages.account.profit_harvest",
                  defaultMessage: "未收穫",
                })
              : intl.formatMessage({
                  id: "pages.account.profit_harvested",
                  defaultMessage: "已收穫",
                })}
          </span>
        );
      },
    },
  ];
  const claim = async () => {
    if (profits.unclaim == 0) {
      Toast.show({
        content: intl.formatMessage({
          id: "pages.account.profit_no_receive",
          defaultMessage: "暫無可领取收益",
        }),
      });
      return;
    }
    await claimProfit(profits.unclaim);
    getProfit()
  };

  const harvestDay = async (item) => {
    console.log(item);
    if (item.status != 0) {
      Toast.show({
        content: intl.formatMessage({
          id: "pages.account.profit_harvested",
          defaultMessage: "已收穫",
        }),
      });
      return;
    }
    const m = Modal.show({
      title: intl.formatMessage({
        id: "pages.account.profit_harvest_title",
        defaultMessage: "通知",
      }),
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
        {
          key: "prev",
          className: "border_btn",
          text: intl.formatMessage({
            id: "common.cancel",
            defaultMessage: "取消",
          }),
        },
        {
          key: "confrim",
          className: "primary_btn",
          text: intl.formatMessage({
            id: "pages.account.profit_to_harvest",
            defaultMessage: "收穫",
          }),
          primary: true,
        },
      ],
      onAction: async (action, index) => {
        m.close();
        if (action.key === "confrim") {
          await harvestProfitByDay(item.block);
          getProfit()
          item.status = 1;
          setHarvests([...harvests]);
        }
      },
      closeOnAction: false,
      content: (
        <ClaimConfrim
          amount={item.amount}
          time={block2date(item.block)}
          intl={intl}
        />
      ),
    });
    return m;
  };
  const harvestDateRange = async () => {
    if (!harvests || !harvests.length) {
      Toast.show({
        content: intl.formatMessage({
          id: "pages.account.profit_no_harvest",
          defaultMessage: "暫無可收穫收益",
        }),
      });
      return;
    }
    const m = Modal.show({
      title: intl.formatMessage({
        id: "pages.account.profit_harvest_title",
        defaultMessage: "通知",
      }),
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
        {
          key: "prev",
          className: "border_btn",
          text: intl.formatMessage({
            id: "common.cancel",
            defaultMessage: "取消",
          }),
        },
        {
          key: "confrim",
          className: "primary_btn",
          text: intl.formatMessage({
            id: "pages.account.profit_to_harvest",
            defaultMessage: "收穫",
          }),
          primary: true,
        },
      ],
      onAction: async (action, index) => {
        m.close();
        if (action.key === "confrim") {
          await harvestProfitByDateRange(
            date2block(rangeDate[0]),
            date2block(rangeDate[1])
          );
          loadHarvest();
          getProfit()
        }
      },
      closeOnAction: false,
      content: (
        <Tip
          from={rangeDate[0].toLocaleDateString()}
          to={rangeDate[1].toLocaleDateString()}
          intl={intl}
        />
      ),
    });
  };

  return (
    <Container {...props}>
      <Flex2 style={{ marginBottom: "1.0rem" }}>
        <img
          className="avatar"
          style={{ width: "3.8rem" }}
          src="/image/default_avatar.png"
          alt="avatar"
        />
        <Text>
          {intl.formatMessage({
            id: "pages.account.profit_accumulated_profit",
            defaultMessage: "累計收益",
          })}
        </Text>
      </Flex2>
      <CellBox list={cellData} />
      <div>
        <Btn className="primary_btn" onClick={claim}>
          {intl.formatMessage({
            id: "pages.account.profit_to_receive",
            defaultMessage: "領取收益",
          })}
        </Btn>
      </div>
      <Text>
        {intl.formatMessage({
          id: "pages.account.profit_receive_record",
          defaultMessage: "收益記錄",
        })}
      </Text>
      <Flex>
        <Calendar
          type="range"
          minDate={new Date(2020, 0, 1)}
          maxDate={new Date()}
          value={rangeDate}
          onConfirm={(data) => {
            console.log("rangeDate", data);
            setRangeDate([data[0], data[1]]);
            loadHarvest(data[0], data[1]);
          }}
        >
          {(val, actions) => (
            <Record onClick={() => actions.open()}>
              {val
                ? val.map((el) => el.toLocaleDateString()).join("~")
                : intl.formatMessage({
                    id: "pages.account.profit_select_date",
                    defaultMessage: "请选择日期",
                  })}
            </Record>
          )}
        </Calendar>

        <Btn2 onClick={harvestDateRange}>
          {intl.formatMessage({
            id: "pages.account.profit_harvest_all",
            defaultMessage: "一键收穫",
          })}
        </Btn2>
      </Flex>
      <List
        list={harvests}
        loading={loading}
        header={headers}
        onClick={harvestDay}
      />
    </Container>
  );
}

const Container = styled.div`
  padding: 2.0rem .7rem;
`;
const Text = styled.div`
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 2.0rem;
  display: inline-block;
  vertical-align: super;
  margin-left: 1.0rem;
`;

const Flex2 = styled.div`
  display: flex;
  align-items: center;
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  margin-bottom: 2.0rem;
`;

const Record = styled.div`
  border-radius: 1.2rem;
  border: .15rem solid #000;
  padding: 2px 1.0rem;
`;

const Btn = styled.div`
  width: 15.8rem;
  text-align: center;
  margin: 2.2rem auto;
  box-shadow: 1px 1px .0rem #000;
`;
const Btn2 = styled.div`
  background: #ed7335;
  width: 9.5rem;
  border: .15rem solid #000;
  color: #fff;
  border-radius: 1.2rem;
  text-align: center;
  height: 2.1rem;
  line-height: 2.1rem;
`;
